<template>
    <div class="row">
        <div class="col-12">
            <div class="card mb-2">
                <div class="card-body pb-0" v-if="travaContinuar == 0">
                    <div class="row">
                        <div class="col-12 col-lg-8 mb-3">
                            <label><i class="fas fa-crown font-13 color-theme mr-1"></i><span class="font-15"> Preenchido por:</span></label>
                            <input disabled type="text" class="form-control required rounded" maxlength="200" v-model="usuario.nomeAdm" style="background-color: #222427 !important;"/>  
                        </div>
                        <div class="col-12 col-lg-2 mb-3">
                            <label><i class="fas fa-calendar-alt font-13 color-theme mr-1"></i><span class="font-14" > Data do preenchimento</span></label>
                            <input disabled type="date" class="form-control rounded" v-model="usuario.dataInscricao" ref="dataInscricaoInput" style="background-color: #222427 !important; " />
                        </div>
                        <div class="col-12 col-lg-2 mb-2">
                            <label><i class="fas fa-pennant font-13 color-theme mr-1"></i><span class="font-14"> Direcionado: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Aluno (a)', 'Comunidade', 'Diretor (a)', 'Vice-diretor (a)', 'Pedagogo (a)', 'Professor (a)', 'Estagiário (a)', 'Zelador (a)','Merendeira', 'Segurança']" v-model="usuario.comunidade"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.comunidade">
                                <option v-for="(option, index) in ['Todos', 'Aluno (a)', 'Comunidade', 'Diretor (a)', 'Vice-diretor (a)', 'Pedagogo (a)', 'Professor (a)', 'Estagiário (a)', 'Zelador (a)','Merendeira', 'Segurança']" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <hr style="background-color: white;">
                    <div class="row">
                        <div class="col-12 col-lg-7 mb-3">
                            <label><i class="far fa-user font-13 color-theme mr-1"></i><span class="font-14"> Nome completo: </span></label>
                            <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.nomeCompleto" placeholder="Nome do usuário"/>  
                        </div>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="far fa-file-alt font-13 color-theme mr-1"></i><span class="font-14" > CPF: </span></label>
                            <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.cpf"  placeholder="CPF do usuário" v-mask="'###.###.###-##'"/>  
                        </div>
                        <div class="col-12 col-lg-2 mb-3">
                            <label><i class="fas fa-birthday-cake font-13 color-theme mr-1"></i><span class="font-14"> Data de nascimento: </span></label>
                            <input type="date" class="form-control rounded" maxlength="8" v-model="usuario.dataNascimento"/>
                        </div>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-graduation-cap font-13 color-theme mr-1"></i><span class="font-14"> Escola: </span></label>
                            <input disabled type="text" class="form-control required rounded" maxlength="200" v-model="dadosEscola.nome" placeholder="Nome da escola" style="background-color: #222427 !important;"/>  
                        </div>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-map-marker-alt font-13 color-theme mr-1"></i><span class="font-14"> Bairro: </span></label>
                            <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.nomeBairro" placeholder="Nome do bairro da pessoa"/>  
                        </div>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="fas fa-road font-13 color-theme mr-1"></i><span class="font-14"> Rua: </span></label>
                            <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.nomeRua" placeholder="Nome da rua da pessoa"/>  
                        </div>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="fas fa-map-pin font-13 color-theme mr-1"></i><span class="font-14"> Nº:</span></label>
                            <input type="number" class="form-control required rounded" maxlength="200" v-model="usuario.numeroCasa" placeholder="Número da casa da pessoa"/>  
                        </div>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="fas fa-mobile-alt font-13 color-theme mr-1"></i><span class="font-14"> Celular:</span></label>
                            <input type="" class="form-control rounded" maxlength="16" v-model="usuario.celular" placeholder="(41) 9 0000-0000" v-mask="'(##) # ####-####'"/>
                        </div>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="fas fa-books font-13 color-theme mr-1"></i><span class="font-14"> Escolaridade: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo','Pós graduação incompleto', 'Pós graduação completo']" v-model="usuario.escolaridade"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.escolaridade">
                                <option v-for="(option, index) in ['Ensino fundamental incompleto', 'Ensino fundamental completo', 'Ensino médio incompleto', 'Ensino médio completo', 'Ensino superior incompleto', 'Ensino superior completo','Pós graduação incompleto', 'Pós graduação completo']" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                        <transition name="slide-up">
                            <div class="col-12 col-lg-3 mb-3 " v-if="usuario.escolaridade == 'Ensino superior incompleto' || usuario.escolaridade == 'Ensino superior completo' || usuario.escolaridade == 'Pós graduação incompleto' || usuario.escolaridade == 'Pós graduação completo'">
                                <label><i class="far fa-graduation-cap font-13 color-theme mr-1 "></i><span class="font-14"> Graduação</span></label>
                                <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.graduacao" placeholder="Digite aqui"/> 
                            </div>
                        </transition>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="fas fa-heartbeat font-13 color-theme mr-1 "></i><span class="font-14 "> Estado civil: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Solteiro', 'Casado', 'Separado', 'Divorciado', 'Viúvo', 'Vivem juntos', 'Religioso']" v-model="usuario.estadoCivil"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.estadoCivil">
                                <option v-for="(option, index) in ['Solteiro', 'Casado', 'Separado', 'Divorciado', 'Viúvo', 'Vivem juntos', 'Religioso']" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                        <transition name="slide-up">
                            <div class="col-12 col-lg-9 mb-3" v-if="usuario.estadoCivil == 'Casado'">
                                <label><i class="fas fa-ring font-13 color-theme mr-1"></i><span class="font-14"> Casamento: </span></label>
                                <v-select class="rounded" title="Desktop" :options="['Primeiro casamento','Segundo casamento','Terceiro casamento','Quarto casamento','Quinto casamento']" v-model="usuario.quantosCasamentos"/>
                                <select title="Mobile" class="form-control rounded" v-model="usuario.quantosCasamentos">
                                    <option v-for="(option, index) in ['Primeiro casamento','Segundo casamento','Terceiro casamento','Quarto casamento','Quinto casamento']" :key="index" :value="option">{{ option }}</option>
                                </select>
                            </div>
                        </transition>
                        <transition name="slide-up ">
                            <div class="col-12 p-0 mb-2" v-if="usuario.estadoCivil == 'Casado'">
                                <div class="col-12" v-for="(conjuge, index) in usuario.conjuges" :key="index">
                                    <label><i class="fas fa-user-tag font-13 color-theme mr-1"></i><span class="font-14"> Nome do cônjuge</span></label>
                                    <div class="">
                                        <input type="text" class="form-control required rounded" maxlength="200" v-model="conjuge.nome" placeholder="Nome completo do cônjuge"/>
                                        <input type="date" class="form-control required mt-1 mb-2 rounded" maxlength="200" v-model="conjuge.nascimento"/>
                                        <input type="text" class="form-control required rounded" maxlength="200" v-model="conjuge.descricao" placeholder="Obs"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="col mt-3" v-if="travaBtn2 >= 1 && travaBtn2 < 15">
                                            <button class=" btn btn-secondary w-100 rounded rounded" @click="adicionarConjuge">
                                                <i class="fas fa-plus font-13  mr-1"></i> Adicionar
                                            </button>
                                        </div>
                                        <div class="col mt-3" v-if="travaBtn2 > 1">
                                            <button class=" btn btn-secondary w-100 rounded rounded" @click="removerUltimoConjuge">
                                                <i class="fas fa-minus font-13 mr-1"></i> Remover
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <transition name="slide-up">
                            <div class="col-12 col-lg-3 mb-3 " v-if="usuario.estadoCivil == 'Vivem juntos'">
                                <label><i class="fas fa-user-friends font-13 color-theme mr-1"></i><span class="font-14"> Nome do amásio</span></label>
                            <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.nomeConjuge" placeholder="Nome do amásio completo"/> 
                            </div>
                        </transition>
                        <transition name="slide-up">
                            <div class="col-12 col-lg-3 mb-3 " v-if="usuario.estadoCivil == 'Vivem juntos'">
                                <label><i class="fas fa-birthday-cake font-13 color-theme mr-1"></i><span class="font-14"> Data de nascimento do amásio</span></label>
                                <input type="date" class="form-control required rounded" maxlength="200" v-model="usuario.dataNascimentoConjuge" placeholder="Data de nascimento do amásio"/> 
                            </div>
                        </transition>
                        <div class="col-12 col-lg-3 mb-3">
                            <label><i class="far fa-baby font-13 color-theme mr-1"></i><span class="font-14"> Filhos: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Não tem','Tem filhos',]" v-model="usuario.temFilhos"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.temFilhos">
                                <option v-for="(option, index) in ['Não tem','Tem filhos',]" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                        <transition name="slide-up ">
                            <div class="col-12 p-0 mb-2" v-if="usuario.temFilhos == 'Tem filhos'">
                                <div class="col-12" v-for="(filho, index) in usuario.filhos" :key="index">
                                    <label><i class="fas fa-user-tag font-13 color-theme mr-1"></i><span class="font-14"> Nome do filho(a)</span></label>
                                    <div class="">
                                        <input type="text" class="form-control required rounded" maxlength="200" v-model="filho.nome" placeholder="Nome completo do filho(a)"/>
                                        <input type="date" class="form-control required mt-1 mb-2 rounded" maxlength="200" v-model="filho.nascimento" placeholder="Nome completo do filho(a)"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="col mt-3" v-if="travaBtn >= 1 && travaBtn < 15">
                                            <button class=" btn btn-secondary w-100 rounded rounded" @click="adicionarFilho">
                                                <i class="fas fa-plus font-13  mr-1"></i> Adicionar
                                            </button>
                                        </div>
                                        <div class="col mt-3" v-if="travaBtn > 1">
                                            <button class=" btn btn-secondary w-100 rounded rounded" @click="removerUltimoFilho">
                                                <i class="fas fa-minus font-13 mr-1"></i> Remover
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                    
                            </div>
                        </transition>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-home font-13 color-theme mr-1"></i><span class="font-14"> Mora com: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Sozinho','Pais', 'Amigos','Cônjuge']" v-model="usuario.moradia"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.moradia">
                                <option v-for="(option, index) in ['Sozinho','Pais', 'Amigos','Cônjuge']" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-paste font-13 color-theme mr-1"></i><span class="font-14"> Possui casa: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Cedida', 'Própria quitada', 'Própria financiada', 'Alugada']" v-model="usuario.possuiCasa"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.possuiCasa">
                                <option v-for="(option, index) in ['Cedida', 'Própria quitada', 'Própria financiada', 'Alugada']" :key="index" :value="option" >{{ option }}</option>
                            </select>
                        </div>
                        <transition name="slide-up">
                            <div class="col-12 col-lg-6 mb-3 " v-if="usuario.possuiCasa == 'Própria financiada' || usuario.possuiCasa == 'Alugada'">
                                <label><i class="fas fa-dollar-sign font-13 color-theme mr-1"></i><span class="font-14"> Valor casa:</span></label>
                                <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.valorCasa" placeholder="Valor e descrição opcional"/> 
                            </div>
                        </transition>
                        <div class="col-12 col-lg-6 mb-3">
                            <label><i class="fas fa-car font-13 color-theme mr-1"></i><span class="font-14"> Possui veículo: </span></label>
                            <v-select class="rounded" title="Desktop" :options="['Não possui','Próprio quitado', 'Financiado',]" v-model="usuario.possuiVeiculo"/>
                            <select title="Mobile" class="form-control rounded" v-model="usuario.possuiVeiculo">
                                <option v-for="(option, index) in ['Não possui','Próprio quitado', 'Financiado',]" :key="index" :value="option">{{ option }}</option>
                            </select>
                        </div>
                        <transition name="slide-up">
                            <div class="col-12 col-lg-6 mb-3 " v-if="usuario.possuiVeiculo == 'Financiado'">
                                <label><i class="fas fa-dollar-sign font-13 color-theme mr-1"></i><span class="font-14"> Valor veículo:</span></label>
                                <input type="text" class="form-control required rounded" maxlength="200" v-model="usuario.valorVeiculo" placeholder="Valor e descrição opcional"/> 
                            </div>
                        </transition>
                        <div class="col-12">
                            <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="continuar()">
                                <i class="fas fa-long-arrow-right mr-1"></i><span class="font-14 font-weight-bold">Continuar</span>
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="card-body pb-0" v-if="travaContinuar == 1">
                    <div class="">
                        <div class="mb-4">
                            <h3 class="d-flex align-center justify-content-center">Dados cadastrais</h3>
                        </div>
                        <pergunta v-for="(pergunta, index) in usuario.perguntas" :key="index" :pergunta="pergunta" :index="index" :travaContinuar="travaContinuar" />
                        <div class="row">
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="voltar()">
                                    <i class="fas fa-long-arrow-left mr-1"></i><span class="font-14 font-weight-bold">Voltar</span>
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="continuar()">
                                    <i class="fas fa-long-arrow-right mr-1"></i><span class="font-14 font-weight-bold">Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body pb-0" v-if="travaContinuar == 2">
                    <div class="">
                        <div class="mb-4">
                            <h3 class="d-flex align-center justify-content-center">Suas preferências</h3>
                        </div>
                        <pergunta v-for="(pergunta, index) in usuario.perguntas" :key="index" :pergunta="pergunta" :index="index" :travaContinuar="travaContinuar" />
                        <div class="row">
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="voltar()">
                                    <i class="fas fa-long-arrow-left mr-1"></i><span class="font-14 font-weight-bold">Voltar</span>
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="continuar()">
                                    <i class="fas fa-long-arrow-right mr-1"></i><span class="font-14 font-weight-bold">Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body pb-0" v-if="travaContinuar == 3">
                    <div>
                        <div class="mb-4">
                            <h3 class="d-flex align-center justify-content-center">Diagnóstico do nível de estresse</h3>
                        </div>
                        <div class="row">
                            <diagnostico v-for="(diagnostico, index) in usuario.perguntas" :key="index" :diagnostico="diagnostico" :travaContinuar="travaContinuar" :index="index" @addPontuacao="addPontuacao($event)" />
                        </div>
                        <div class="mt-2 mb-2 col d-flex text-center ">
                            <div class="col-6 justify-content-center">
                                Total de pontos: {{resultado}}
                            </div>
                            <div class="col-6 justify-content-center">
                                Itens selecionados: {{itensSelecionados}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="voltar()">
                                    <i class="fas fa-long-arrow-left mr-1"></i><span class="font-14 font-weight-bold">Voltar</span>
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="continuar()">
                                    <i class="fas fa-long-arrow-right mr-1"></i><span class="font-14 font-weight-bold">Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body pb-0" v-if="travaContinuar == 4">
                    <div class="">
                        <div class="mb-4">
                            <h3 class="d-flex align-center justify-content-center">Diagnóstico de estudo espiritual das pessoas</h3>
                        </div>
                        <pergunta v-for="(pergunta, index) in usuario.perguntas" :key="index" :pergunta="pergunta" :index="index" :travaContinuar="travaContinuar" />
                        <div class="row">
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="voltar()">
                                    <i class="fas fa-long-arrow-left mr-1"></i><span class="font-14 font-weight-bold">Voltar</span>
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-secondary w-100 mt-2 mb-3 rounded" @click="finalizar()">
                                    <i class="fa fa-save font-13 mr-1"></i><span class="font-14 font-weight-bold">Finalizar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import { mapState } from 'vuex'
import pergunta from '@/components/Pergunta.vue'
import diagnostico from '@/components/alunos/Diagnostico.vue'

export default {
	name: 'Adicionar',
    computed: {
        ... mapState({
            urlRest: state => state.urlRest,
            dadosUsuario: state => state.dadosUsuario,
            dadosEscola: state => state.dadosEscola,
        })
    },
    data() {
        return {
            resultado: 0,
            itensSelecionados: 0,
            travaContinuar: 0,
            usuario: {
                image: '',
                nomeAdm : '',
                idAutor: '',
                dataInscricao: '',
                comunidade: 'Aluno (a)',
                nomeCompleto: '',
                cpf:'',
                dataNascimento: '',
                nomeEscola:'',
                nomeIgreja:'',
                nomeBairro:'',
                nomeRua: '',
                numeroCasa: '',
                celular: '',
                escolaridade: 'Ensino fundamental incompleto',
                estadoCivil: 'Solteiro',
                nomeConjuge: '',
                dataNascimentoConjuge: '',
                moradia:'Sozinho',
                temFilhos:'Não tem',
                quantosCasamentos: 'Primeiro casamento',
                possuiCasa: 'Cedida',
                valorCasa: '',
                graduacao: '',
                possuiVeiculo:'Não possui',
                valorVeiculo: '',
                filhos: [
                    {'nome': null, 'nascimento': null},
                ],
                conjuges: [
                    {'nome': null, 'nascimento': null, 'descricao': null},
                ],
                perguntas: []
            },
            selecionado: {},
            dataAtual: '',
            isMobile: false,
            travaBtn: 1,
            travaBtn2: 1,
            
        };
    },  
    components: {
       pergunta, diagnostico
    },
    methods: {
        getPerguntas() {
            this.checkWindowSize();
            window.addEventListener('resize', this.checkWindowSize);

            let ref = this;
            this.$axios({
                method: 'get',
                url: this.urlRest +'service/getPergunta',
                params: {
                    tela: 0,
                },
                headers: {
                    'Content-Type': 'application/json'
                },

            }).then(response => {
                ref.usuario.perguntas = response.data;
            })

        },
        adicionarFilho() {
            this.usuario.filhos.push({ nome: null, nascimento: null });
            this.travaBtn += 1
        },
        removerUltimoFilho() {
            this.usuario.filhos.pop();
            this.travaBtn -= 1
        },
        adicionarConjuge() {
            this.usuario.conjuges.push({ nome: null, nascimento: null });
            this.travaBtn2 += 1
        },
        removerUltimoConjuge() {
            this.usuario.conjuges.pop();
            this.travaBtn2 -= 1
        },
        continuar() {
            this.travaContinuar = this.travaContinuar + 1
        },
        voltar() {
            this.travaContinuar = this.travaContinuar - 1
        },
        checkWindowSize() {
            this.isMobile = window.innerWidth <= 767.98;
        },
        setDataAtual() {
            const data = new Date();
            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const dia = String(data.getDate()).padStart(2, '0');
            this.dataAtual = `${ano}-${mes}-${dia}`;
        },
        limparInputs() {
            this.travaContinuar = 0,
            this.usuario.comunidade = 'Aluno (a)',
            this.usuario.image = '',
            this.usuario.dataInscricao = '',
            this.usuario.nomeCompleto = '',
            this.usuario.cpf = '',
            this.usuario.dataNascimento = '',
            this.usuario.dataNascimentoConjuge = '',
            this.usuario.nomeEscola = '',
            this.usuario.nomeIgreja = '',
            this.usuario.nomeBairro ='',
            this.usuario.nomeRua = '',
            this.usuario.numeroCasa = '',
            this.usuario.celular = '',
            this.usuario.escolaridade = 'Ensino superior completo',
            this.usuario.estadoCivil = 'Solteiro',
            this.usuario.nomeConjuge = '',
            this.usuario.moradia = 'Sozinho',
            this.usuario.temFilhos = 'Não tem',
            this.usuario.possuiCasa = 'Cedida',
            this.usuario.valorCasa = '',
            this.usuario.possuiVeiculo = 'Não possui',
            this.usuario.valorVeiculo = '',
            this.usuario.quantosCasamentos = 'Primeiro casamento'
        },
        finalizar() {
            let ref = this;
            this.$store.dispatch('alternarTelaCarregamento', true);
            if(ref.usuario.nomeCompleto != '') {
                this.$axios({
                    method: 'post',
                    url: this.urlRest +'service/adicionarAluno',
                    headers: {
                        'Content-Type': 'application/json'
                    },

                    data: this.usuario
                }).then(function () {
                    ref.$toast.fire({
                        icon: 'success',
                        title: 'Cadastro finalizado!',
                        timer: 2500,
                    })
                    ref.limparInputs(),
                    ref.travaContinuar = 0
                }).catch(function (error) {
                    if (error.response != undefined) {
                        if (error.response.status == 408) {
                            ref.$store.dispatch('deslogar')

                            ref.$toast.fire({
                                icon: 'warning',
                                title: 'Sessão expirada!'
                            });
                        } else {
                            ref.$toast.fire({
                                icon: 'error',
                                title: 'Erro: ' + error.response.status
                            })
                        }
                        } else {
                            ref.$toast.fire({
                                icon: 'error',
                                title: error
                            })
                        }
                    }).finally(() => {
                        this.$store.dispatch('alternarTelaCarregamento', false);
                    }); 
            } else {
                this.$store.dispatch('alternarTelaCarregamento', false);
                ref.$toast.fire({
                    icon: 'error',
                    title: 'Preencha o nome completo!'
                })
                this.travaContinuar = 0
            }      
        },
        addPontuacao(pergunta) {
            let index = this.usuario.perguntas.findIndex(p => p.id == pergunta.id);

            if (pergunta.descricao != 'true') {
                pergunta.descricao = 'true';
                this.resultado = this.resultado + pergunta.nivel
                this.itensSelecionados += 1
            } else {
                pergunta.descricao = 'false';
                this.resultado = this.resultado - pergunta.nivel
                this.itensSelecionados -= 1
            }

            this.$set(this.usuario.perguntas, index, pergunta)
        },
        atualizarDataInscricao() {
            const dataAtual = new Date().toISOString().substr(0, 10);
            this.usuario.dataInscricao = dataAtual;
            setTimeout(this.atualizarDataInscricao, 1000); // Atualizar a cada segundo (opcional)
        },
    },
    mounted() {
        this.getPerguntas()
        this.usuario.nomeAdm = this.dadosUsuario.usuarioNome
        this.usuario.idAutor = this.dadosUsuario.usuarioId
        this.usuario.idEscola = this.dadosEscola.id
        this.usuario.nomeEscola = this.dadosEscola.nome
        this.atualizarDataInscricao();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkWindowSize);
    }
}
    
</script>

<style scoped>
   .switch input[type="checkbox"]:not(:checked) + .slider {
      background-color: #3c3e42
   }
   input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(50%);
   }
    .slide-up-enter-active {
        transition: all 0.4s;
    }

    .slide-up-enter {
        transform: translateY(-100%);
        opacity: 0;
    }

    .slide-up-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

    .ajusteBtn {
      margin-top: 32px;
   }

</style>